import Category from '@/models/Category';
import { Family } from '@/models/Family';
import * as Yup from 'yup';

export const schema = Yup.object().shape({
    name: Yup.string()
        .min(1)
        .required(),
    author: Yup.string().required(),
    editorState: Yup.string().required(),
});

export const formInitialState = {
    mainImage: undefined,
    name: '',
    author: undefined,
    workload: undefined,
    category: {} as Category,
    category2: {} as Category,
    tags: [],
    editorState: '',
    families: [] as Family[],
};

export const formErrors = {
    nameError: false,
    authorError: false,
    categoryError: false,
    category2Error: false,
    tagsError: false,
    editorStateError: false,
};
